module.exports = __webpack_public_path__ + "assets/img/modal-avatar-467402af.png";